import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=4e4ee983&scoped=true&"
import script from "./UserRights.vue?vue&type=script&lang=ts&"
export * from "./UserRights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ee983",
  null
  
)

export default component.exports